"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var storybook_1 = require("@eyecons/storybook");
function FormChannelsCoach(_a) {
    var setUser = _a.setUser, user = _a.user, activeUser = _a.activeUser;
    var _b = react_1.useState({}), role = _b[0], setRole = _b[1];
    react_1.useEffect(function () {
        if (role.name !== 'player') {
            setUser({ channels: [activeUser.channel.id] });
        }
        if (role.name === 'player') {
            setUser({ channels: [] });
        }
    }, [role.id]);
    return react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(storybook_1.Users.FormChannelsNew, { setUser: setUser, user: user, setRole: setRole }),
        role.name === 'player' && react_1.default.createElement(storybook_1.Users.FormChannel, { params: {
                type: 'player',
                club_id: activeUser.channel.id
            }, value: user.channels[0] || null, onChange: function (channel_id) { return setUser({ channels: [channel_id] }); } }));
}
exports.default = FormChannelsCoach;
